import React from 'react';
import Post from '../../components/Post';

function DharmaTalks(props) {
  return (
    <Post {...props} />
  )
}

export default DharmaTalks;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/DharmaTalks/index.js